(() => {
const scheduleProductZoomPreload = main => {
    if (!main) return;
    const run = () => {
      const url = main.dataset.fullImageUrl;
      if (!url || main.dataset.preloadedFullImageUrl === url) return;
      const preload = new Image();
      preload.decoding = 'async';
      preload.src = url;
      main.dataset.preloadedFullImageUrl = url;
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 2500 });
    } else {
      window.setTimeout(run, 1200);
    }
  };

  const initialProductMainImage = document.getElementById('ProductMainImage');
  if (initialProductMainImage) {
    if (document.readyState === 'complete') {
      scheduleProductZoomPreload(initialProductMainImage);
    } else {
      window.addEventListener('load', () => scheduleProductZoomPreload(initialProductMainImage), { once: true });
    }
  }

  document.querySelectorAll('[data-gallery-thumb]').forEach(btn => btn.addEventListener('click', () => {
    const main = document.getElementById('ProductMainImage');
    if (!main) return;
    main.src = btn.dataset.imageUrl;
    if (btn.dataset.imageSrcset) main.srcset = btn.dataset.imageSrcset;
    if (btn.dataset.imageSizes) main.sizes = btn.dataset.imageSizes;
    main.dataset.fullImageUrl = btn.dataset.fullImageUrl || btn.dataset.imageUrl;
    main.dataset.preloadedFullImageUrl = '';
    scheduleProductZoomPreload(main);
    document.querySelectorAll('[data-gallery-thumb]').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');
  }));

  const imageLightbox = document.getElementById('ProductImageLightbox');
  const lightboxOpenButton = document.querySelector('[data-product-lightbox-open]');
  const productMainImage = document.getElementById('ProductMainImage');
  if (imageLightbox && lightboxOpenButton && productMainImage) {
    const lightboxImage = imageLightbox.querySelector('[data-lightbox-image]');
    const zoomInButton = imageLightbox.querySelector('[data-lightbox-zoom-in]');
    const zoomOutButton = imageLightbox.querySelector('[data-lightbox-zoom-out]');
    const zoomLabel = imageLightbox.querySelector('[data-lightbox-zoom-label]');
    const viewport = imageLightbox.querySelector('[data-lightbox-viewport]');
    let zoomLevel = 1;
    let panX = 0;
    let panY = 0;
    let dragStart = null;
    let dragging = false;
    let lightboxReturnFocus = null;

    const renderLightboxImage = () => {
      lightboxImage.style.transform = `translate3d(${panX}px, ${panY}px, 0) scale(${zoomLevel})`;
      lightboxImage.style.cursor = zoomLevel > 1 ? (dragging ? 'grabbing' : 'grab') : 'default';
      if (zoomLabel) zoomLabel.textContent = `${zoomLevel}x`;
      if (zoomOutButton) zoomOutButton.disabled = zoomLevel <= 1;
      if (zoomInButton) zoomInButton.disabled = zoomLevel >= 4;
    };

    const setZoom = next => {
      zoomLevel = Math.max(1, Math.min(4, next));
      if (zoomLevel === 1) {
        panX = 0;
        panY = 0;
      }
      renderLightboxImage();
    };

    const openImageLightbox = () => {
      lightboxReturnFocus = document.activeElement instanceof HTMLElement ? document.activeElement : lightboxOpenButton;
      lightboxImage.src = productMainImage.dataset.fullImageUrl || productMainImage.currentSrc || productMainImage.src;
      zoomLevel = 1;
      panX = 0;
      panY = 0;
      dragStart = null;
      dragging = false;
      renderLightboxImage();
      imageLightbox.classList.add('is-open');
      imageLightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('image-lightbox-open');
      imageLightbox.querySelector('[data-lightbox-zoom-in]')?.focus();
    };

    const closeImageLightbox = () => {
      imageLightbox.classList.remove('is-open');
      imageLightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('image-lightbox-open');
      dragStart = null;
      dragging = false;
      if (lightboxReturnFocus && lightboxReturnFocus.isConnected) lightboxReturnFocus.focus();
      lightboxReturnFocus = null;
    };

    lightboxOpenButton.addEventListener('click', openImageLightbox);
    imageLightbox.querySelectorAll('[data-lightbox-close]').forEach(btn => btn.addEventListener('click', closeImageLightbox));
    zoomInButton?.addEventListener('click', e => { e.stopPropagation(); setZoom(zoomLevel + 1); });
    zoomOutButton?.addEventListener('click', e => { e.stopPropagation(); setZoom(zoomLevel - 1); });

    viewport?.addEventListener('wheel', e => {
      e.preventDefault();
      setZoom(zoomLevel + (e.deltaY < 0 ? 1 : -1));
    }, { passive: false });

    lightboxImage.addEventListener('pointerdown', e => {
      if (zoomLevel <= 1) return;
      e.preventDefault();
      dragging = true;
      dragStart = { x: e.clientX, y: e.clientY, panX, panY };
      lightboxImage.setPointerCapture?.(e.pointerId);
      renderLightboxImage();
    });

    lightboxImage.addEventListener('pointermove', e => {
      if (!dragStart) return;
      panX = dragStart.panX + (e.clientX - dragStart.x);
      panY = dragStart.panY + (e.clientY - dragStart.y);
      renderLightboxImage();
    });

    const endLightboxDrag = e => {
      if (!dragStart) return;
      lightboxImage.releasePointerCapture?.(e.pointerId);
      dragStart = null;
      dragging = false;
      renderLightboxImage();
    };
    lightboxImage.addEventListener('pointerup', endLightboxDrag);
    lightboxImage.addEventListener('pointercancel', endLightboxDrag);

    document.addEventListener('keydown', e => {
      if (!imageLightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeImageLightbox();
      if (e.key === '+' || e.key === '=') setZoom(zoomLevel + 1);
      if (e.key === '-') setZoom(zoomLevel - 1);
      if (e.key === 'Tab') {
        const focusable = Array.from(imageLightbox.querySelectorAll('button:not([disabled]):not(.product-lightbox__backdrop), [href], [tabindex]:not([tabindex="-1"])'))
          .filter(element => !element.hasAttribute('hidden'));
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }


  document.querySelectorAll('[data-variant-select]').forEach(select => select.addEventListener('change', () => {
    const section = select.closest('.product-info') || document;
    document.querySelectorAll('[data-product-variant-input]').forEach(input => input.value = select.value);
    const option = select.selectedOptions[0];
    const price = section.querySelector('[data-product-price]');
    if (price && option?.dataset.price) price.textContent = option.dataset.price;
  }));
})();
